import { useState } from 'react';
import PropTypes from 'prop-types';
import { DangerousHtmlContent, Notification, variants } from '@eti/components';
import { useTranslation } from '@eti/providers';

const ImportantInformationNotification = ({ content, id, title, variant }) => {
  const [isVisible, setIsVisible] = useState(!sessionStorage.getItem(`hide-${id}`));
  const { t } = useTranslation();

  const handleCloseCallback = () => {
    setIsVisible(false);
    sessionStorage.setItem(`hide-${id}`, 'true');
  };

  return isVisible && content ? (
    <Notification
      closeButtonDataTestId={`${id}-close-button`}
      closeButtonLabel={t('Close')}
      dataTestId={id}
      onClose={handleCloseCallback}
      title={title}
      variant={variant}
    >
      <DangerousHtmlContent content={content} />
    </Notification>
  ) : null;
};

ImportantInformationNotification.propTypes = {
  content: PropTypes.string,
  id: PropTypes.string,
  title: PropTypes.string,
  variant: PropTypes.oneOf([variants.INFORMATION, variants.WARNING, variants.CRITICAL]),
};

export default ImportantInformationNotification;
